export default {
  title: 'Webhook-Signatur-Secret',
  warning:
    'Speichern Sie dieses Secret jetzt — es wird nicht erneut angezeigt. Verifizieren Sie damit den X-Webhook-Signature-Header.',
  done: 'Fertig',
};
